// @flow

import * as React from 'react';
import PaginationLink from 'common/components/PaginationLink';

type Props = {|
  currentPage: number,
  totalPages: number,
  firstPageURL: string | null,
  lastPageURL: string | null,
  previousPageURL: string,
  nextPageURL: string,
  onPageChange?: (newPage: number) => mixed
|};

class Pagination extends React.Component<Props> {
  static defaultProps: {| currentPage: number |} = {
    currentPage: 1
  };

  render(): React.Node {
    const {
      currentPage,
      totalPages,
      firstPageURL,
      lastPageURL,
      nextPageURL,
      previousPageURL,
      onPageChange
    } = this.props;

    const firstPageLink = (
      <PaginationLink
        onClick={onPageChange}
        page={1}
        className="button small secondary"
        href={firstPageURL}
      >
        «
      </PaginationLink>
    );

    const lastPageLink = (
      <PaginationLink
        onClick={onPageChange}
        page={totalPages}
        className="button small secondary"
        href={lastPageURL}
      >
        »
      </PaginationLink>
    );

    const previousPageLink = (
      <PaginationLink
        onClick={onPageChange}
        page={currentPage - 1}
        className="button small"
        href={previousPageURL}
        rel="prev"
      >
        {'‹ '}
        <span className="m-pagination-button-text">
          {__('search.pagination.previous')}
        </span>
      </PaginationLink>
    );

    const nextPageLink = (
      <PaginationLink
        onClick={onPageChange}
        page={currentPage + 1}
        className="button small"
        href={nextPageURL}
        rel="next"
      >
        <span className="m-pagination-button-text">
          {__('search.pagination.next')}
        </span>
        {' ›'}
      </PaginationLink>
    );

    if (totalPages > 1) {
      return (
        <div className="m-pagination-container">
          <ul className="m-pagination">
            {currentPage !== 1 && firstPageURL !== null && (
              <li className="m-pagination-first-page-link">{firstPageLink} </li>
            )}
            {currentPage !== 1 && <li>{previousPageLink} </li>}
            <li className="m-pagination-count">
              {__('search.pagination.page')} <strong>{currentPage}</strong> /{' '}
              {totalPages}
            </li>
            {currentPage !== totalPages && <li> {nextPageLink}</li>}
            {currentPage !== totalPages && lastPageURL !== null && (
              <li className="m-pagination-last-page-link"> {lastPageLink}</li>
            )}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default Pagination;
